























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component
export default class CouponSmallItem extends Vue {
  @Prop({ default: {} }) readonly item!: any

  @Emit()
  receiveCoupon() {
    return this.item
  }
}
